import { render, staticRenderFns } from "./side-navbar.vue?vue&type=template&id=5a80142f&scoped=true&"
import script from "./side-navbar.component.ts?vue&type=script&lang=ts&"
export * from "./side-navbar.component.ts?vue&type=script&lang=ts&"
import style0 from "./side-navbar.vue?vue&type=style&index=0&id=5a80142f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80142f",
  null
  
)

export default component.exports